import { createContext, useContext, useEffect, useState } from "react";
import { projectsAPI } from "../services/api"; 

const ProjectContext = createContext(null);

export const ProjectProvider = ({ children }) => {
  const [activeProject, setActiveProject] = useState(null);
  const [projectRole, setProjectRole] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);

  // project team members
  const [projectMembers, setProjectMembers] = useState([]);
  const [projectMembersLoading, setProjectMembersLoading] = useState(false);

  useEffect(() => {
    const projectId = activeProject?.id;
    if (!projectId) {
      setProjectMembers([]);
      return;
    }

    let cancelled = false;

    const loadTeam = async () => {
      setProjectMembersLoading(true);
      try {
        const res = await projectsAPI.getTeam(projectId);
        if (!cancelled) setProjectMembers(res?.data || []);
      } catch (e) {
        console.error("Failed to load project team:", e);
        if (!cancelled) setProjectMembers([]);
      } finally {
        if (!cancelled) setProjectMembersLoading(false);
      }
    };

    loadTeam();
    return () => {
      cancelled = true;
    };
  }, [activeProject?.id]);

  const clearProject = () => {
    setActiveProject(null);
    setProjectRole(null);
    setProjectMembers([]); // reset team when exiting project
  };

  return (
    <ProjectContext.Provider
      value={{
        activeProject,
        setActiveProject,
        projectRole,
        setProjectRole,
        currentUser,
        setCurrentUser,
        projectMembers,            // expose
        setProjectMembers,         // optional
        projectMembersLoading,     // optional
        clearProject,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};

export const useProjectContext = () => {
  const context = useContext(ProjectContext);
  if (!context)
    throw new Error("useProjectContext must be used within ProjectProvider");
  return context;
};
